export default __webpack_public_path__ + "static/leonprofilevideo-3a07985e7afbbcbf052b224210fe8794.mp4";